import { useSelector } from "react-redux";

export const useCurrentUser = () => {
  return useSelector(({ firebase: { auth, profile } }) => ({
    auth,
    profile,
  }));
};
